// extracted by mini-css-extract-plugin
export var banner = "_fg-0";
export var closeButton = "_fg-2";
export var greenCheckmark = "_fg-3";
export var hereLink = "_fg-4";
export var titleIcon = "_fg-1";